import axios from 'axios'
import Config from '../Helpers/Config';
import {requiresRelogin}  from './authActions'


export const updateKeyword = (keyword) => {
    return {
        type: 'UPDATE_CATEGORY_PRODUCTS_KEYWORD',
        keyword: keyword
    }
};

export const fetchProductsByCategory = (categoryId, keyword = '', page = 1) => {

    return function (dispatch) {
        if (!page) {
            page = 1;
        }

        let url = Config.api() + 'search/category/' + categoryId + '/products?page=' + page;
        if (keyword.length) {
            url += '&q=' + keyword;
        }

        dispatch({
            type: 'FETCHING_CATEGORY_PRODUCTS_SEARCH'
        });

        return axios.get(url,{
            withCredentials:Config.withCredentials()
        })
            .then((response) => {

                dispatch({
                    type: 'FETCH_CATEGORY_PRODUCTS_SEARCH',
                    results: response.data
                });

                dispatch({
                    type: 'UPDATE_CATEGORIES_LIST_BREADCRUMB',
                    results: response.data.category[0] || []
                });
            }).catch((error) => {
                if(error.response.status === 401) {
                    dispatch(requiresRelogin(true, true))
                }else {
                    dispatch({
                        type: 'FETCHING_CATEGORY_PRODUCTS_SEARCH_FAILED'
                    });
                }
            });
    };
};

export const fetchCategoriesList = (parentId = '') => {
    return function (dispatch) {
        dispatch({
            type: 'FETCHING_CATEGORIES_LIST'
        });

        let url = Config.api() + 'search/category-list';
        if(parentId){
            url += '/' + parentId;
        }

        return axios.get(url,{
            withCredentials:Config.withCredentials()
        })
            .then((response) => {
                dispatch({
                    type: 'FETCH_CATEGORIES_LIST',
                    results: response.data
                });

            }).catch((error) => {
                if(error.response.status === 401) {
                    dispatch(requiresRelogin(true, true))
                }else {
                    dispatch({
                        type: 'FETCHING_CATEGORIES_LIST_FAILED'
                    });
                }
            });
    };
};

export const resetProducts = () => {
    return function (dispatch) {
        dispatch({
            type: 'RESET_CATEGORY_PRODUCTS_SEARCH',
        });
    };
};

export const resetCategories = () => {
    return function (dispatch) {
        dispatch({
            type: 'RESET_CATEGORIES_LIST_SEARCH',
        });
    };
};
